import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setActiveItinerary as setActiveItineraryAction,
  itineraryLegFocused as itineraryLegFocusedAction,
  itineraryLegCleared as itineraryLegClearedAction,
} from '#/trip-planner/slice';

const useActiveItinerary = () => {
  const { plan, activeItinerary } = useSelector(s => s.tripPlanner);

  const dispatch = useDispatch();
  const setActiveItinerary = useCallback(
    id => {
      dispatch(
        setActiveItineraryAction(plan.itineraries.find(it => it.id === id))
      );
    },
    [dispatch, plan]
  );

  const itineraryLegFocused = useCallback(
    focusedLegIndex => dispatch(itineraryLegFocusedAction({ focusedLegIndex })),
    [dispatch]
  );

  const itineraryLegCleared = useCallback(
    () => dispatch(itineraryLegClearedAction()),
    [dispatch]
  );

  return {
    activeItinerary,
    setActiveItinerary,
    itineraryLegFocused,
    itineraryLegCleared,
  };
};

export default useActiveItinerary;
